<template lang="pug">
.stepup
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li.active
      span {{ $t('Service Questions') }}

  .row.margin-top
    .col-sm-6.text-center.col-menu(v-if="isSystemManagement || isHumanStaff")
      router-link.btn.btn-warning.btn-lg.btn-menu(to="/service_question/questions")
        i.fa.fa-pencil-square-o
        p {{ $t('Service Questions List') }}
    .col-sm-6.text-center.col-menu
      router-link.btn.btn-success.btn-lg.btn-menu(to="/service_question/results")
        i.fa.fa-line-chart
        p {{ $t('Service Questions Result List') }}

</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'service-question',
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    }
  },
  components: {
    AppHeader
  }
}

</script>



// WEBPACK FOOTER //
// ServiceQuestion.vue?3342a51a